import React, { useState, useContext, Fragment } from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Tools from "./JNSTools";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import SettingsUserPreferences from "./SettingsUserPreferences";
import SettingsDashboardSetup from "./SettingsDashboardSetup_sf";
import SettingsGanttChart from "./SettingsGanttChart";
import SettingsInstance from "./SettingsInstance";
import SettingsIssues from "./SettingsIssues";
import SettingsRequirements from "./SettingsRequirements";
import SettingsMaintenance from "./SettingsMaintenance";
import SettingsProjects from "./SettingsProjects";
import { CredsContext } from "./Contexts";

import "./styles/MainToolbar.css";

function SettingsContainer(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [selectedPage, setSelectedPage] = useState("User Preferences");
  const [dirty, isDirty] = useState(false);

  let tabList = [
    "User Preferences",
    //"Dashboard Configuration",
    "Maintenance Tasks",
  ];
  if (projectObject) {
    if (creds.userType == "generic") {
      tabList = [
        "User Preferences",
        //"Dashboard Configuration",
        //"Project Settings",
        //"Gantt Chart Settings",
        //"Issues Settings",
        //"Requirements Settings",
      ];
    } else {
      tabList = [
        "User Preferences",
        "SPP Instance Settings",
        //"Dashboard Configuration",
        "Gantt Chart Settings",
        //"Issues Settings",
        "Project Settings",
        //"Requirements Settings",
        "Maintenance Tasks",
      ];
    }
  }

  if (props.settingsPage && selectedPage == "User Preferences") {
    setSelectedPage(props.settingsPage);
  }

  //comment
  const drawerWidth = "230px";
  const handleSettingsChange = (setting, newTarget) => {
    if (setting) {
      const key = Object.keys(setting)[0];
      const value = Object.values(setting)[0];
      const rawSettings = localStorage.getItem("oadaSettings");
      let settingsFromLocalStorage;
      if (rawSettings) {
        settingsFromLocalStorage = JSON.parse(rawSettings);
      }
      const newSettings = settingsFromLocalStorage
        ? { ...settingsFromLocalStorage, [key]: value }
        : { [key]: value };

      localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
      Tools.writeSettings(creds, projectObject.id);
    }
    if (newTarget) {
      props.handleClose(newTarget);
    }
    isDirty(!dirty);
  };

  let pageToDisplay;
  switch (selectedPage) {
    case "User Preferences":
      pageToDisplay = (
        <SettingsUserPreferences
          handleSettingsChange={handleSettingsChange}
          setTarget={props.setTarget}
        />
      );
      break;
    case "Dashboard Configuration":
      pageToDisplay = (
        <SettingsDashboardSetup
          handleSettingsChange={handleSettingsChange}
          setLock={props.setLock}
        />
      );
      break;
    case "Gantt Chart Settings":
      pageToDisplay = (
        <SettingsGanttChart handleSettingsChange={handleSettingsChange} />
      );
      break;
    case "Issues Settings":
      pageToDisplay = (
        <SettingsIssues handleSettingsChange={handleSettingsChange} />
      );
      break;
    case "Project Settings":
      pageToDisplay = (
        <SettingsProjects
          handleSettingsChange={handleSettingsChange}
          projectObject={projectObject}
        />
      );
      break;
    case "Requirements Settings":
      pageToDisplay = (
        <SettingsRequirements
          handleSettingsChange={handleSettingsChange}
          projectObject={projectObject}
        />
      );
      break;
    case "SPP Instance Settings":
      pageToDisplay = (
        <SettingsInstance handleSettingsChange={handleSettingsChange} />
      );
      break;
    case "Maintenance Tasks":
      pageToDisplay = (
        <SettingsMaintenance handleSettingsChange={handleSettingsChange} />
      );
      break;
  }

  const handleClick = (event) => {
    setSelectedPage(event.target.id);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Drawer
        className="settingsDialogClass"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            bgcolor: "#154360",
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <List>
          {tabList.map((text) => (
            <Fragment key={text}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={handleClick}
                  className="settingsSectionButton"
                  selected={selectedPage == text}
                  id={text}
                >
                  {text}
                </ListItemButton>
              </ListItem>
              {text == "SPP Instance Settings" || text == "Project Settings" ? (
                <Divider
                  sx={{ margin: "30px 10px", backgroundColor: "white" }}
                />
              ) : null}
            </Fragment>
          ))}
        </List>
      </Drawer>
      <Box sx={{ flexGrow: 1, position: "fixed", bottom: 0, right: 0 }}>
        <Typography textAlign="right">
          Version 1.2 build 7, 2025-05-07, 20:50 CST
        </Typography>
      </Box>
      {pageToDisplay}
    </Box>
  );
}

SettingsContainer.propTypes = {
  setTarget: PropTypes.func,
  setLock: PropTypes.func,
  handleClose: PropTypes.func,
  settingsPage: PropTypes.string,
};

export default SettingsContainer;
